import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcHomeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.897 2.93a1.75 1.75 0 0 1 2.207 0l7 5.688c.408.332.646.831.646 1.358V19.5A1.75 1.75 0 0 1 19 21.25h-3.75a1.75 1.75 0 0 1-1.75-1.75v-4.25h-3v4.25a1.75 1.75 0 0 1-1.75 1.75H5a1.75 1.75 0 0 1-1.75-1.75V9.976c0-.527.238-1.026.646-1.358z"
  }));
}
var IcHomeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHomeFill));

export { IcHomeFill as I };
